<template lang="pug">
  v-main.h-full(:class="{'dark-theme': darkTheme}")
    Header
    v-app
      template(v-if="showNonAuthLayout()")
        router-view
      template(v-else)
        SideBar
        .content-body
          router-view
          ModalFeedback(v-if="!isAdmin" v-model="isNeedPoll")
          GoogleReminder
    Footer
    ModalApp(v-if="isShowModalApp" @emitModal="modalState = $emit")
    ModalGlobalDialog
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ModalGlobalDialog from '@/components/Modals/ModalGlobalDialog.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    ModalGlobalDialog,
    SideBar: () => import('@/components/SideBar'),
    ModalFeedback: () => import('@/components/Modals/ModalFeedback'),
    ModalApp: () => import('@/components/Modals/ModalApp'),
    Hello: () => import('@/views/Hello'),
    GoogleReminder: () => import('@/components/Google/Reminder')
  },
  data() {
    return {
      modalState: sessionStorage.getItem('modalApp') || sessionStorage.setItem('modalApp', 'show'),
      isDataLoading: false,
      isDataLoaded: false
    }
  },
  computed: {
    ...mapState({
      login: state => state.profile.clientProfile.login,
      windowWidth: state => state.app.windowWidth,
      darkTheme: state => state.app.isDarkTheme
    }),
    isNeedPoll: {
      get() {
        return this.$store.state.feedback.isReady
      },
      set(value) {
        if (!value) this.dismissFeedback()
      }
    },
    isShowModalApp() {
      return !this.isAdmin && this.windowWidth <= 600 && this.modalState === 'show'
    },
    isAdmin() {
      return this.$store.getters.isAdmin()
    }
  },
  watch: {
    // Single source of truth for the theme: the store flag drives Vuetify's own theme, so every
    // control — including detached content like menus, tooltips and dialogs, which always follow the
    // root theme — gets its dark palette from the framework instead of hand-written overrides.
    darkTheme: {
      handler(isDark) {
        this.$vuetify.theme.dark = Boolean(isDark)
      },
      immediate: true
    },
    '$i18n.locale'() {
      document.title = this.$t('metaTitle')
    },
    '$route.name': {
      handler() {
        this.loadData()
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions([
      'changeWidth',
      'getBill',
      'getInternetTariffsInfo',
      'getTariffs',
      'getTVInfo',
      'getTVTariff',
      'getServices',
      'getMessages',
      'getFeedbackStatus',
      'dismissFeedback'
    ]),
    onResize() {
      this.changeWidth(window.innerWidth)
    },
    showNonAuthLayout() {
      return this.$route.meta.guest || !this.$auth.isAuth() || ['choose-account', 'admin'].includes(this.$route.name)
    },
    async loadData() {
      if (this.showNonAuthLayout() || this.isDataLoaded || this.isDataLoading) return

      this.isDataLoading = true
      try {
        // The router guard already loaded the profile, and the API layer refreshes an expired
        // access token before any request goes out, so the core data can all fire in parallel.
        await Promise.all([
          this.getBill(),
          this.getInternetTariffsInfo(),
          this.getTariffs(),
          this.getTVInfo(),
          this.getTVTariff(),
          this.getServices(),
          this.getMessages(),
          this.getFeedbackStatus()
        ])

        this.isDataLoaded = true
      } catch (error) {
        console.error('Failed to load data:', error)
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>
